import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ContentChildren, QueryList } from '@angular/core';
import { AbTestItemDirective } from "./ab-test-item.directive";
import { CommonModule } from "@angular/common";

@Component({
  selector: 'app-ab-test',
  template: `
  <ng-container *ngIf="!!displayedItem">
    <ng-container [ngTemplateOutlet]="displayedItem.templateRef"></ng-container>
  </ng-container>
    `,
  standalone: true,
  imports: [
    CommonModule,
    AbTestItemDirective,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AbTestComponent implements AfterViewInit {

  @ContentChildren(AbTestItemDirective) items: QueryList<AbTestItemDirective>;
  displayedItem: AbTestItemDirective;

  constructor(
    private cdr: ChangeDetectorRef,
  ) { }

  ngAfterViewInit() {

    let totalWeight = 0;
    const ranking: Array<AbTestRank> = [];
    this.items.forEach((item, index) => {
      ranking.push({
        index,
        start: totalWeight + 1,
        end: totalWeight + item.appAbTestConfig.ratio,
      });
      totalWeight += item.appAbTestConfig.ratio;
    })
    const chance = Math.floor(Math.random() * totalWeight);
    const rankingSelected = ranking.find((item) => item.start <= chance && item.end >= chance);
    this.displayedItem = this.items.filter((el, index) => rankingSelected.index === index)[0];
    this.cdr.detectChanges();
  }

}

export interface AbTestRank {
  index: number;
  start: number;
  end: number;
}
